define.alias("shared/components/shared/social/instagram-connect-modal", "settings/components/shared/social/instagram-connect-modal");